<template>
  <div class="two-by-two-container" :class="{ shown: visible }">
    <div
      v-for="(quad, index) in beatData.quadrants"
      class="quadrant"
      :class="{ image: quad.backgroundImage }"
      :key="`quad-${index}`"
      :style="quad.backgroundImage ? `background-image: url(${quad.backgroundImage})` : ''"
    >
      <div v-if="quad.copy" class="copy" v-html="quad.copy"></div>
      <div v-if="quad.video" class="rollover-video" :class="{ shown: activeVideos.includes(index) }" :ref="`rollover-${index}`">
        <video
          :src="quad.video"
          :ref="`vid-${index}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    beatData: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeVideos: []
    }
  },
  watch: {
    visible: function(val) {
      if (val) {
        this.playVideos()
      } else {
        this.activeVideos = []
        this.stopVideos()
      }
    }
  },
  methods: {
    playVideos () {
      let vidCount = 0
      for(let i = 0; i < 4; i++) {
        let target = this.$refs[`vid-${i}`]
        if (target) {
          vidCount++
          setTimeout(() => {
            if (this.visible) {
              this.activeVideos.push(i)
              target[0].muted = false
              target[0].play()
            }
            target[0].addEventListener('ended', () => {
              const arrTarget = this.activeVideos.indexOf(i)
              if (arrTarget !== -1) this.activeVideos.splice(arrTarget, 1)
            }, false)
          }, vidCount * 2500)
        }
      }
    },
    stopVideos () {
      for(let i = 0; i < 4; i++) {
        let target = this.$refs[`vid-${i}`]
        if (target) {
          target[0].pause()
          target[0].muted = true
          target[0].currentTime = 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

.two-by-two-container {
  height: 100%;
  height: -webkit-fill-available;

  .quadrant {
    position: relative;
    display: inline-block;
    vertical-align: top;
    // height: 50%;
    height: 50vh;
    width: 50%;

    &.image {
      @include bg-cover-center;
      background-color: white;
    }

    .rollover-video {
      @include fill-parent;
      overflow: hidden;

      &.shown video {
        opacity: 1;
        transition: .5s opacity;
      }

      img.touch {
        position: absolute;
        width: 40px;
        top: $space-ml;
        right: $space-ml;
      }
      
      video {
        @include center-in-parent;
        opacity: 0;
        transition: .5s opacity;

        height: 100%;
        width: 89vh;
        min-width: 100%;
        min-height: 28.125vw;
      }
    }

    .copy {
      @include center-in-parent;
      width: 100%;
      padding: $space-ml;
      font-size: 50px;

      @include media($bp-desktop-xxl) {
        font-size: $font-size-ml;
      }

      @include media($bp-desktop-xl) {
        font-size: $font-size-m;
      }
      @include media($bp-desktop-l) {
        font-size: $font-size-ms;
      }
      @include media($bp-desktop-s) {
        
      }
      @include media($bp-tablet) {
        padding: $space-s;
      }

      ::v-deep .slide-cover {
        @include fill-parent;
        background-color: black;
        animation: slideShrink .5s ease 0s 1 normal forwards;
      }

      // ::v-deep is a deep selector for classes injected through v-html
      ::v-deep .half {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        width: 50%;

        &.small {
          line-height: 1.05em;
        }
      }

      ::v-deep .large {
        font-size: 240px;
        transform: translateY(20px);
        text-transform: uppercase;
        text-align: center;

        @include media($bp-desktop-xl) {
          font-size: 200px;
        }
        @include media($bp-desktop-l) {
          font-size: 160px;
        }
        @include media($bp-desktop-s) {
          font-size: 120px;
        }
      }
    }
  }
}
@keyframes slideShrink {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
</style>